import { Login2faRequiredDto } from "./Login2faRequiredDto";
import { LoginResponseDto } from "./LoginResponseDto";

export type LoginResult = LoginResponseDto | Login2faRequiredDto;

export const isTwoFactorRequired = (
  result: LoginResult,
): result is Login2faRequiredDto =>
  (result as Login2faRequiredDto).twoFactorRequired === true;
